import { PoliticSpaceApi } from "../../../../Shared/Constants/api";
import axiosInstance from "../../../../Shared/Utils/axiosInstance";

export const deletePoliticSpaceApi = async (id) => {
  try {
    let response = await axiosInstance.delete(`${PoliticSpaceApi}/${id}`);

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
